<template>
	<el-container id="xiaozu" v-loading="loading">
		<!-- <div class="xzBody">
			<div class="xzHead">
				<p class="createXz"><b>+</b>新建小组</p>
			</div>
			<dl class="xzList">
				<dd v-for="index of xznum" :key="index">
					<div class="xzLogo">
						<img :src="defaUlogo">
					</div>
					<div class="xzInfo">
						<p class="xzName">广州华商职业学院交流组</p>
						<p class="xzMsg">
							<span>共享给：3214人</span>
							<span>话题：16</span>
						</p>
					</div>
					<div class="xzCtrl">
						<span class="ding">置顶</span>
						<span class="out">退出</span>
					</div>
				</dd>
			</dl>
		</div> -->
		<div class="nodata">
			<img :src="nodataImg">
			<p>待更新</p>
		</div>
	</el-container>
</template>

<script>

export default {
	name: 'xiaozu'
	,data () {
		return {
			xznum:3
			,form: {
				name: '',
				region: '',
				date1: '',
				date2: '',
				delivery: false,
				type: [],
				resource: '',
				desc: ''
			}
			,formLabelWidth: '120px'
			,loading:true
		}
	}
	,mounted:function(){
		this.loading=false;
	}
	,methods:{
	}
}
</script>
<!-- scoped单页面有效属性 -->

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/xiaozu.vue